import(/* webpackMode: "eager" */ "/home/jenkins/agent/workspace/pperfunnel-ui-v1_hotfix_26.10.28@2/app/v3/[...slug]/error.tsx");
